<script setup>
const usuarioStore = useUsuarioStore()
const pushStore = usePushNotificationsStore()
const permissaoStore = usePermissaoStore()

// Inicializa o sistema de logout automático por inatividade
if (process.client) {
  useIdleLogout()
}

// Inicializa push notifications
const { initialize, isAvailable } = usePushNotifications()

onMounted(async () => {
  if (process.client && isAvailable.value) {
    // Inicializa o sistema de notificações
    await initialize()

    // Verifica se deve mostrar o modal de opt-in após 5 segundos
    if (pushStore.shouldShowOptInModal()) {
      setTimeout(() => {
        pushStore.showOptInModal()
      }, 5000)
    }
  }

  // Carrega configuração de trava de competência
  if (process.client) {
    try {
      await permissaoStore.buscarConfiguracaoTravaCompetencia()
      console.log('Configuração de trava carregada:', permissaoStore.permitirEdicaoCompetenciaFechada)
    } catch (error) {
      console.warn('Erro ao carregar configuração de trava:', error)
    }
  }
})

defineExpose({
  name: 'DefaultLayout',
})
</script>

<template>
  <div>
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100">
      <AppHeader />
      <div class="body flex-grow-1">
        <Toast />
        <CContainer :key="useStore().key" class="px-4" fluid>
          <NuxtPage :key="usuarioStore.cartorioAtual.id" />
          <Loading />
        </CContainer>
        <!-- <AppFloatingButton /> -->
        <LivroDiarioAuxiliarModalAdicionarReceita />
        <LivroDiarioAuxiliarModalImportarXml />
        <ModalCadastrarCliente />
        <ModalBPOImportarCliente />
        <ModalBPOLancarDespesa @despesa-salva="usePrestacaoDeContaStore().fetchDespesas({ competencia: useStore().competenciaFormatada })" />
        <ModalBPOEditarDespesa />
        <ModalBPODetalhesDaDespesa />
        <ModalBPOEfetuarPagamento />
        <ModalLivroDiarioAuxiliarDetalhesReceita />
        <ModalBPOReceitaFixa />
        <ModalBPOReceitaBpo />
        <OrcamentosModalAdicionarAto />
        <LivroDiarioAuxiliarModalFiltrosAvancados />
        <LivroDiarioAuxiliarModalDownloadComprovantes />
        <ModalInatividade />

        <!-- Modal de opt-in para push notifications -->
        <PushNotificationOptInModal
          v-model:visible="pushStore.optInModalVisible"
        />

        <!-- Modal de despesas filtradas -->
        <ModalBPOVisualizarDespesasFiltradas />

        <!-- SpeedDial para ações rápidas -->
        <SpeedDial />
      </div>
      <AppFooter />
    </div>
  </div>
</template>
